import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import { useDispatch, useSelector } from "react-redux";
import { apiGetPersons, apiPersonsList } from "api/personApi";
import BasicSelect from "components/BasicInputs/BasicSelect";
import { getQueryParam, setQueryParam } from "helpers/queryParam";

export default function TableSelectPerson({
    refetch,
}: {
    refetch: (paginationState: any, token: any, productId: any) => void;
}) {
    const fromDate = useSelector((state: any) => state.appReducer.fromDate);
    const toDate = useSelector((state: any) => state.appReducer.toDate);

    const dispatch = useDispatch();

    //@ts-ignore
    const { token } = useSelector((state) => state).businessReducer.business;

    //@ts-ignore
    const personReducer = useSelector((state) => state).personReducer;

    //@ts-ignore
    const paginationState = useSelector((state) => state.paginationReducer);

    // useEffect(() => {
    //   //@ts-ignore
    //   dispatch(apiGetPersons({ pagination: { limit: 10000, page: 1, notTable: true }, token }));
    // }, [token]);

    const onChange = (val: any) => {
        if (val) {
            //@ts-ignore
            let options = [];
            if (fromDate && toDate) {
                options = [
                    { key: "subColumn", value: "date" },
                    { key: "searchText", value: fromDate },
                    { key: "searchTextAlt", value: toDate },
                ];
            }

            setQueryParam("personId", val);
            //@ts-ignore
            return dispatch(refetch({ pagination: paginationState, token, search: options, id: val }));
        } else {
            const id = getQueryParam("personId");
            //@ts-ignore
            return dispatch(refetch({ pagination: paginationState, token, id }));
        }
    };

    return (
        <Box
            sx={{
                minWidth: 120,
                maxWidth: 330,
                alignItems: "center",
                display: "flex",
                justifyContent: "space-between",
            }}
        >
            <FormControl fullWidth sx={{ maxWidth: 300 }}>
                <BasicSelect
                    style={{ minWidth: 245 }}
                    options={personReducer?.allPerson ? personReducer?.allPerson : []}
                    onChange={onChange}
                    placeholder="شخص"
                    withSearch
                    withRefresh
                    refreshList={() => {
                        const paginations = { limit: 10000, page: 1, notTable: true }
                        //@ts-ignore
                        dispatch(apiPersonsList(token, "all", () => {

                        }))

                    }
                    }
                />
                {/* <TableAutoComplete
          queryParam="personId"
          options={personReducer?.allPerson ? personReducer?.allPerson : []}
          onChange={onChange}
        /> */}
            </FormControl>
        </Box>
    );
}
